import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ConveraWidgetWrapper from "../../components/ConveraWidgetWrapper";
import Loader from "../../components/ui/Loader";
import Modal from "../../components/ui/Modal";
import { decryptData } from "../../utils";

const ConveraPaymentPage = () => {
  const [sellerInfoXML, setSellerInfoXML] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<any>(false);
  const navigate = useNavigate();
  const uid = useParams<{ uid?: string }>();

  useEffect(() => {
    if (uid) {
      const storedSellerInfo = sessionStorage.getItem("sellerInfoXML");
      const decrpyptedSellerInfo = decryptData(storedSellerInfo ?? "");

      if (decrpyptedSellerInfo) {
        setSellerInfoXML(decrpyptedSellerInfo);
        sessionStorage.removeItem("generatedUDID");
      } else {
        navigate("/convera");
      }
    }
  }, [uid, navigate, sellerInfoXML]);

  return (
    <div className="flex flex-col justify-center items-center px-[76px] py-[76px] bg-gradient-to-b from-[#E0F2FF] via-[#F7FAFC] to-[#F7FAFC] w-full max-w-full h-full">
      {sellerInfoXML ? (
        <div className="flex flex-col justify-center items-center w-full">
          <button
            className="outline-none border-none rounded-[68px] mb-[30px] max-w-[280px] self-center flex justify-center items-center gap-[10px] px-6 py-4 text-white bg-[#0f5bf1] font-inter text-[14px] font-semibold leading-[14px] w-full hover:opacity-90 disabled:bg-[#d1d1d1] disabled:cursor-not-allowed"
            onClick={() => {
              setIsModalOpen("cancelReasons");
            }}
          >
            Back to K2 - Convera page
          </button>
          <ConveraWidgetWrapper sellerInfo={sellerInfoXML} />
        </div>
      ) : (
        <Loader />
      )}
      <Modal
        // header="Cancel Transaction"
        headerClass={"text-white"}
        modalClass="!p-0 rounded lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "cancelReasons"}
        closeHandler={() => setIsModalOpen("")}
        closable={false}
      >
        <div className="flex flex-col items-center px-5 py-10 space-y-6">
          <div className="flex flex-col items-center space-y-2">
            <span className="font-ssp text-[18px] font-bold ">
              Are you sure you want to return to the home page?
            </span>
            <span className="text-[14px] font-ssp text-center max-w-[388px]">
              If a transaction hasn’t been created yet (i.e., you haven’t received a reference
              number), any progress made will not be saved.
            </span>
          </div>
          <div className="flex justify-center w-full space-x-5">
            <button
              onClick={() => navigate("/convera")}
              className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
            >
              Yes
            </button>
            <button
              onClick={() => setIsModalOpen("")}
              className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConveraPaymentPage;
